import { memo, MouseEvent, useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import { ArrowCornerIcon } from "@icons";
import { markEventBlocked } from "@design-system/ViewTable/ViewTable.lib";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import tableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import {
    FieldReviewDetailsRow,
    FieldReviewTableCallbacks,
} from "../fieldReviewDetailsViewConfig";
import styles from "../../cells/HistoryDetailsCells.module.scss";

export const FieldReviewActionsCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, FieldReviewDetailsRow, string>) => {
        const meta = useViewTableMeta<FieldReviewTableCallbacks, unknown>(
            table,
        );
        const onRowAction = meta.callbacks?.onRowAction;

        const handleClick = useCallback(
            (event: MouseEvent<HTMLButtonElement>) => {
                markEventBlocked(event);
                onRowAction?.(row.original);
            },
            [onRowAction, row.original],
        );

        if (!row.original.transactionId) {
            return <ViewTableCell className={styles.actions} />;
        }

        return (
            <ViewTableCell className={styles.actions}>
                <div className={styles.actionsButtons}>
                    <Button
                        variant="primary"
                        size="md"
                        onClick={handleClick}
                        title="View transaction"
                        aria-label="View transaction"
                        iconOnly
                        className={tableStyles.showOnHover}
                    >
                        <ArrowCornerIcon />
                    </Button>
                </div>
            </ViewTableCell>
        );
    },
);

FieldReviewActionsCell.displayName = "FieldReviewActionsCell";
